'use strict';

/* jshint -W098 */
angular.module('mean.messages').controller('MessageDetailController', ['$scope', 'Global', 'Messages', 'MessageDetail', '$filter', 'Users', 'MeanUser', 'Archives', 'MessageReply', '$location',
  function($scope, Global, Messages, MessageDetail, $filter, Users, MeanUser, Archives, MessageReply, $location) {
    $scope.global = Global;
    $scope.package = {
      name: 'messages'
    };

    $scope.total_messages = 0;
    $scope.total_unread = 0;
    $scope.total_inbox = 0;

    $scope.options = {
            height: 150,
            toolbar: []
    };

    var message = MessageDetail.get();

    if(!message) {
      $location.path('mail');
    }

    Users.query({}, function(users) {
      $scope.users = user;
      $scope.sender = $filter('filter')(users, {'_id': message.sender}, true)[0];
    })

    Messages.query({'_id': message._id}, function(returned) {
      if(returned.length !== 1) {
        //alert('Problem with getting the message ' + message._id + ' number returned: ' + returned.length);
        $location.path('mail');
      } else {
        $scope.message_detail = returned[0];
        $scope.message_detail.status = 'read';
        $scope.message_detail.$update();
      }
    });

    Messages.query({'receiver': MeanUser.user._id, 'where': 'sender subject date folder status'}, function(messages) {
      $scope.my_messages = $filter('orderBy')(messages, '-date', false);
      $scope.my_inbox_messages = $filter('filter')($scope.my_messages, {'folder': 'inbox'}, true);

      $scope.total_messages = $scope.my_messages.length;

      var unread = 0;
      var inbox = 0;
      $scope.my_messages.forEach(function(message) {
        if(message.folder === 'inbox') {
          inbox = inbox + 1;
        
          if(message.status === 'unread') {
            unread = unread + 1;
          }
        }
      });

      $scope.total_inbox = inbox;
      $scope.total_unread = unread;
    });

    $scope.getSendersName = function() {
      return user.name;
    };

    $scope.moveToTrash = function() {
      if($scope.message_detail.sender === MeanUser.user._id) return;

      if($scope.message_detail.folder === 'trash') {
        //this message is already in trash so we're gonna
        //move it to the archives and remove from the active list
        var tmp = new Archives({
          sender: $scope.message_detail.sender,
          receiver: $scope.message_detail.receiver,
          date: $scope.message_detail.date,
          status: $scope.message_detail.status,
          folder: $scope.message_detail.folder,
          subject: $scope.message_detail.subject,
          body: $scope.message_detail.body
        });

        tmp.$save();
        $scope.message_detail.$delete();
        return;
      }

      $scope.message_detail.folder = 'trash';
      $scope.message_detail.$update();
    };

    $scope.reply = function() {
      $scope.message_detail.reply = true;
      MessageReply.set($scope.message_detail);
    };

    $scope.forward = function() {
      $scope.message_detail.forward = true;
      MessageReply.set($scope.message_detail);
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/messages/public/controllers/messageDetail.js